import { SET_SUPPORTED_BROWSER_VERSIONS } from './constants';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchBrowserVersions() {
  return dispatch => {
    // optionally you can have getState as the second argument

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.

      const doRequest = axios.create({baseURL: window.location.href}).get('misc/supported-browser-versions.json');

      doRequest.then(res => {
        dispatch({
          type: SET_SUPPORTED_BROWSER_VERSIONS,
          data: res.data,
        });
        resolve(res);
      });

      /* mock array for now to test it in local*/
      // const res =  {
      //   "chrome": [
      //     "104",
      //     "105",
      //     "106"
      //   ],
      //   "firefox": [
      //     "102",
      //     "103",
      //     "104"
      //   ],
      //   "safari": [
      //     "13",
      //     "14",
      //     "15"
      //   ],
      //   "microsoft edge": [
      //     "103",
      //     "104",
      //     "105"
      //   ]
      // };

      // dispatch({
      //   type: SET_SUPPORTED_BROWSER_VERSIONS,
      //   data: res
      // });
      // resolve(res);
      /* mock end */
    });

    


    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SET_SUPPORTED_BROWSER_VERSIONS:
      // Just after a request is sent
      return {
        ...state,
        supportedBrowserVersions: action.data,
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/common/redux/SupportedBrowserVersion.js